// frontend/src/services/tiktokService.js
import axios from "axios";

// Configurar URL base según el entorno
const BASE_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace('/api/content', '')
  : 'http://localhost:8000';

// Crear instancia de axios para TikTok
const tiktokApi = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const tiktokService = {
  /**
   * Obtener comentarios de los videos recientes de TikTok
   * @param {string} tiktokUserId - ID del usuario de TikTok
   * @param {number} limitVideos - Número de videos recientes a analizar (default: 10)
   * @param {number} commentsPerVideo - Comentarios máximos por video (default: 50)
   * @param {boolean} analyze - Si se debe analizar el sentimiento (default: false)
   */
  getComments(tiktokUserId, limitVideos = 10, commentsPerVideo = 50, analyze = false) {
    return tiktokApi.get("/api/tiktok/comments/", {
      params: {
        tiktok_user_id: tiktokUserId,
        limit_videos: limitVideos,
        comments_per_video: commentsPerVideo,
        analyze: analyze
      },
    });
  },

  /**
   * Analizar sentimiento de comentarios de TikTok ya guardados
   * @param {string} tiktokUserId - ID del usuario de TikTok (optional)
   * @param {string} videoId - ID del video específico (optional)
   * @param {number} days - Número de días hacia atrás para analizar (default: 30)
   */
  analyzeSentiment(tiktokUserId = null, videoId = null, days = 30) {
    return tiktokApi.post("/api/tiktok/comments/sentiment/", {
      tiktok_user_id: tiktokUserId,
      video_id: videoId,
      days: days
    });
  },

  /**
   * Obtener todas las cuentas de TikTok conectadas del usuario autenticado
   */
  getAccounts() {
    return tiktokApi.get("/api/tiktok/accounts/");
  },
};

export default tiktokService;
